import type { MailboxInfo } from 'owa-client-types';

export interface CopilotAccountOption {
    mailboxInfo: MailboxInfo;
}

export interface CopilotAccountPickerStore {
    currentAccount: MailboxInfo | null;

    unsavedSelectedAccount: MailboxInfo | null;
    dialogState: DialogState;
    bannerState: BannerState;
    /** Available account options for the picker */
    accountOptions: CopilotAccountOption[];
}

export enum DialogState {
    LOADING,
    LOADED,
    CLOSED,
}

export enum BannerState {
    HIDDEN,
    SHOWN,
}
